var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowParent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37115e-08 10L0 11L5 16L10 11V10L6 10L6 4L15 4V2L4 2L4 10H4.37115e-08Z",
    fill: "#959697"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowParent);
export default __webpack_public_path__ + "static/media/arrowParent.5642e68736a3f3f3df2efa09c27514bd.svg";
export { ForwardRef as ReactComponent };